import { hasClassName, isAnchor, isParagraph } from "../../utils/dom-utils";

const INLINE_CARD = '.j-inline-card';

export const hasInlineCardAfterSecondParagraph = ($articlesChildren) =>
  isParagraph($articlesChildren[0]) &&
  isParagraph($articlesChildren[1]) &&
  isAnchor($articlesChildren[2]) && hasClassName($articlesChildren[2], INLINE_CARD.replace(".", ""));

  export const hasInlineCardBetweenFirstParagraphs = ($articlesChildren) =>
    isParagraph($articlesChildren[0]) &&
    isAnchor($articlesChildren[1]) && hasClassName($articlesChildren[1], INLINE_CARD.replace(".", ""))
    && isParagraph($articlesChildren[2]);
